import { SystemMessageListResponse } from "@app/model/api/system/SystemMessageListResponse";

export class SiteState {
    // API Responses
    systemMessages: SystemMessageListResponse | undefined;


}